import {
  API_STATES
} from '@/helpers'
  
const state = {
  benefitsGetState       : API_STATES.NOT_REQUESTED,
  benefitsGetError       : null,
  benefitDeleteState     : API_STATES.NOT_REQUESTED,
  benefitDeleteError     : null,
  benefitCreateState     : API_STATES.NOT_REQUESTED,
  benefitCreateError     : null,
  benefits               : [],
  benefitUpdateState     : API_STATES.NOT_REQUESTED,
  benefitUpdateError     : null,
  userBenefitUpdating    : [],
  userBenefitUpdateError : null,
  userBenefitDeleting    : [],
  userBenefitDeleteError : null,
  userBenefits           : [],
  benefit                : {}
}

export default state
  